import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, Scale, Globe, HelpCircle } from 'lucide-react';

const SupportResources = () => {
  const navigate = useNavigate();
  
  const articles = [
    {
      title: "Contact Information for Each Office",
      description: "Directory of voivodeship offices and contact details",
      icon: Users,
      path: "/knowledge-base/support-resources/office-contacts"
    },
    {
      title: "Legal Support Options",
      description: "Find legal assistance and immigration lawyers",
      icon: Scale,
      path: "/knowledge-base/support-resources/legal-support"
    },
    {
      title: "Community Resources",
      description: "Connect with expat communities and support groups",
      icon: Globe,
      path: "/knowledge-base/support-resources/community-resources"
    },
    {
      title: "FAQ for Common Questions",
      description: "Answers to frequently asked questions about immigration and life in Poland",
      icon: HelpCircle,
      path: "/knowledge-base/support-resources/faq"
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 bg-primary/10 rounded-lg">
              <Users className="h-8 w-8 text-primary" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4">
            Support Resources
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Find help and connect with support services for your immigration journey
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {articles.map((article, index) => {
            const Icon = article.icon;
            return (
              <Card
                key={index}
                className="hover:shadow-lg transition-all duration-300 cursor-pointer"
                onClick={() => navigate(article.path)}
              >
                <CardHeader>
                  <div className="flex items-center space-x-4">
                    <div className="p-2 bg-primary/10 rounded-lg">
                      <Icon className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <CardTitle className="text-xl text-foreground">{article.title}</CardTitle>
                      <CardDescription className="mt-1">{article.description}</CardDescription>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="flex justify-end">
                    <span className="text-primary">Read More →</span>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-12 bg-card rounded-lg p-6 border border-border">
          <h2 className="text-2xl font-bold text-foreground mb-4">Need Additional Help?</h2>
          <p className="text-muted-foreground mb-6">
            If you can't find the information you need in these resources, consider:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
            <li>Contacting your nearest Polish consulate or embassy</li>
            <li>Reaching out to expat communities on social media</li>
            <li>Consulting with an immigration lawyer</li>
            <li>Visiting your local voivodeship office in person</li>
          </ul>
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => navigate('/knowledge-base')}
            className="text-primary hover:text-primary/80 transition-colors"
          >
            ← Back to Knowledge Base
          </button>
        </div>
      </div>
    </div>
  );
};

export default SupportResources; 